import { useContext, useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { ReactComponent as Arrow } from "../../assets/newImages/icons/arrowLeft.svg";
import { EmpresaContext } from "../../contexts/Empresa/EmpresaContext";
import { useTheme } from "../../contexts/Theme/ThemeContext";
import { BreadcrumbsContainer } from "./styles";

const Breadcrumbs: React.FC = () => {
  const { theme } = useTheme();

  const location = useLocation();
  const { id, name, trilhaId, trilhaNome, duplicated, token } = useParams();

  const { empresa, setEmpresa } = useContext(EmpresaContext);
  const nomeUsuario = empresa?.usuario;

  const [breadcrumbs, setBreadcrumbs] = useState<Array<any>>([]);

  function verificaNovoProduto() {
    var url = window.location.href;
    var regex = /\/0$/;
    return regex.test(url);
  }

  const getPeriodoDoDia = () => {
    const horaAtual = new Date().getHours();

    if (horaAtual >= 5 && horaAtual < 12) {
      return "Bom dia";
    } else if (horaAtual >= 12 && horaAtual < 18) {
      return "Boa tarde";
    } else {
      return "Boa noite";
    }
  };

  const routes = [
    //primarias
    { path: "painel", label: "Meu painel", link: "/" },
    { path: "perfil", label: "Minha conta", link: "/perfil/usuarios" },
    { path: "destaques", label: "Destaques", link: "/destaques" },
    { path: "compartilhar", label: "Compartilhar", link: "/compartilhar" },
    { path: "metricas", label: "Métricas", link: "/metricas" },
    //clube conectado
    {
      path: "clube-conectado",
      label: "Clube Conectado",
      link: "/clube-conectado",
    },
    {
      path: "trilha",
      // na tela da aula a trilha vem em trilhaId/trilhaNome; na tela da trilha vem em id/name
      label: trilhaNome || name || "Trilha",
      link: `/clube-conectado/trilha/${trilhaId || id}${
        trilhaNome || name ? "/" + (trilhaNome || name) : ""
      }`,
      onVoltar: "/clube-conectado",
    },
    {
      path: "aula",
      label: name ? name : "Aula",
      link: trilhaId
        ? `/clube-conectado/trilha/${trilhaId}/${trilhaNome}/aula/${id}/${name}`
        : `/clube-conectado/aula/${id}${name ? "/" + name : ""}`,
      onVoltar: trilhaId
        ? `/clube-conectado/trilha/${trilhaId}/${trilhaNome}`
        : "/clube-conectado",
    },
    //secundarias
    { path: "pedidos", label: "Pedidos", link: "painel/pedidos" },
    {
      path: "credenciais",
      label: "Enviar Credenciais",
      link: "painel/credenciais/" + token,
      onVoltar: "/painel",
    },
    {
      path: "configuracoes",
      label: "Configurar",
      link: "painel/configuracoes",
    },
    {
      path: "usuarios",
      label: "Usuários",
      link: "/perfil/usuarios",
    },
    {
      path: "assinatura",
      label: "Assinatura",
      link: "/assinatura",
    },
    {
      path: "trocar-plano",
      label: "Trocar de plano",
      link: "/assinatura/trocar-plano",
      onVoltar: "/assinatura",
    },
    { path: "pedidos", label: "Meus pedidos", link: "/painel/pedidos" },
    {
      path: "sacolas-abandonadas",
      label: "Sacolas abandonadas",
      link: "/painel/sacolas-abandonadas",
    },
    { path: "catalogos", label: "Meus Catálogos", link: "/painel/catalogos" },
    { path: "produtos", label: "Meus produtos", link: "/painel/produtos" },
    {
      path: "produto",
      label: `${verificaNovoProduto() ? "Novo produto" : "Editando Produto"}`,
      link: "/painel/produtos/produto/",
    },
    {
      path: "pedido",
      // o número exibido vem no state da navegação (a URL usa o id interno)
      label: (location.state as any)?.id_pedido_sequencial
        ? `Pedido #${(location.state as any).id_pedido_sequencial}`
        : "Pedido",
      link: `/painel/pedidos/pedido/${id}`,
      onVoltar: "/painel/pedidos",
    },
    {
      path: "relatorios",
      label: "Meus relatórios",
      link: "/painel/relatorios",
      onVoltar: id ? "/painel/relatorios" : "",
    },
    //terciarias
    {
      path: "informacoes-erp",
      label: "Informações do ERP",
      link: "/painel/produtos/informacoes-erp",
      onVoltar: "/painel/produtos",
    },
    {
      path: "importar-imagens",
      label: "Carregar imagens",
      link: "/painel/produtos/importar-imagens",
      onVoltar: id ? "/painel/produtos/importar-imagens" : "/painel/produtos",
    },
    {
      path: "importar-produtos",
      label: "Adicionar em massa",
      link: "/painel/produtos/importar-produtos",
      onVoltar: "/painel/produtos"
    },
    {
      path: "sacola-abandonada",
      label: `${name ? "Sacola de " + name : "Sacola #" + id}`,
      link: `/painel/sacolas-abandonadas/sacola-abandonada/${id}`,
      onVoltar: "/painel/sacolas-abandonadas",
    },
    {
      path: "catalogo",
      label: `${name} ${duplicated ? "- Cópia" : ""}`,
      link: `/painel/catalogos/catalogo/${id}/${!name || /^\.+$/.test(name) ? '_' + (name || '') : encodeURIComponent(name).replace(/\./g, '%2E')}${
        duplicated ? "/duplicado" : ""
      }`,
      onVoltar: "/painel/catalogos",
    },
    {
      path: "planos",
      label: "Planos",
      link: "/perfil/usuarios/planos",
    },
    //quaternarias
    {
      path: "ajustar",
      label: "Ajustar produtos",
      link: "/painel/produtos/importar-produtos/ajustar",
      onVoltar: "/painel/produtos/importar-produtos"
    },
  ];

  useEffect(() => {
    if (location) {
      let newBreadcrumbs: Array<Object> = [];
      let paths = location.pathname.split("/").filter((str) => Boolean(str));

      // /assinatura* pertence ao agrupamento "Minha conta" do menu, mas a
      // URL não tem segmento pai — injeta sinteticamente.
      // Em /assinatura/trocar-plano o caminho deve ser só "Assinatura / Trocar de plano".
      if (paths[0] === "assinatura" && !paths.includes("trocar-plano")) {
        newBreadcrumbs.push({
          label: "Minha conta",
          link: "/perfil/usuarios",
        });
      }

      paths.forEach((path) => {
        newBreadcrumbs.push(routes.filter((route) => route.path == path)[0]);
      });
      newBreadcrumbs = newBreadcrumbs.filter(
        (breadcrumb) => breadcrumb != undefined,
      );

      setBreadcrumbs(newBreadcrumbs);
    }
  }, [location.pathname]);

  return (
    <BreadcrumbsContainer theme={theme}>
      {location.pathname == "/" && (
        <div className="saudacao hideMobile fonteSubtitulo">
          {getPeriodoDoDia()}, <span>{nomeUsuario}</span>
        </div>
      )}
      {location.pathname != "/" && breadcrumbs.length >= 1 && (
        <>
          {breadcrumbs.some((breadcrumb) => breadcrumb.onVoltar) && (
            <Link
              to={
                breadcrumbs.filter((breadcrumb) => breadcrumb.onVoltar)[breadcrumbs.filter((breadcrumb) => breadcrumb.onVoltar).length - 1]
                  .onVoltar
              }
              className="voltar fonteRotulos"
            >
              <Arrow className="arrow" />
              <span>Voltar</span>
            </Link>
          )}
          {breadcrumbs.map((breadcrumb, index, arr) => (
            <span
              key={index}
              className={`fonteSubtiulo palavra ${
                arr.length > 1
                  ? index == arr.length - 1
                    ? "laranja"
                    : "verde"
                  : "verde bold"
              }`}
            >
              <Link to={breadcrumb.link} style={{ textDecoration: "none" }}>
                {breadcrumb.label}
              </Link>
              {index !== arr.length - 1 && <span className="barra">/</span>}
            </span>
          ))}
        </>
      )}
    </BreadcrumbsContainer>
  );
};

export default Breadcrumbs;
